/**
 * Toolbar Settings Storage
 * 
 * Utility functions for localStorage persistence of toolbar settings per campaign.
 * Settings like snapToGrid, ganttSwimlane are stored per-campaign.
 */

// LocalStorage keys
const SNAP_TO_GRID_KEY = 'flow-snap-to-grid';
const GANTT_SWIMLANE_KEY = 'gantt-swimlane';

/**
 * Get stored snap-to-grid setting from localStorage
 */
export const getStoredSnapToGrid = (campaignId) => {
  if (!campaignId) return false;
  try {
    const stored = localStorage.getItem(`${SNAP_TO_GRID_KEY}_${campaignId}`);
    return stored !== null ? JSON.parse(stored) : false;
  } catch {
    return false;
  }
};

/**
 * Save snap-to-grid setting to localStorage
 */
export const saveSnapToGrid = (campaignId, isEnabled) => {
  if (!campaignId) return;
  try {
    localStorage.setItem(`${SNAP_TO_GRID_KEY}_${campaignId}`, JSON.stringify(isEnabled));
  } catch (e) {
    console.warn('Failed to save snap-to-grid setting:', e);
  }
};

/**
 * Get stored Gantt swimlane setting from localStorage
 * Default is 'none' (no grouping) - same as Kanban
 */
export const getStoredGanttSwimlane = (campaignId) => {
  if (!campaignId) return 'none';
  try {
    const stored = localStorage.getItem(`${GANTT_SWIMLANE_KEY}_${campaignId}`);
    return stored !== null ? JSON.parse(stored) : 'none';
  } catch {
    return 'none';
  }
};

/**
 * Save Gantt swimlane setting to localStorage
 */
export const saveGanttSwimlane = (campaignId, swimlane) => {
  if (!campaignId) return;
  try {
    localStorage.setItem(`${GANTT_SWIMLANE_KEY}_${campaignId}`, JSON.stringify(swimlane));
  } catch (e) {
    console.warn('Failed to save Gantt swimlane setting:', e);
  }
};
